var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',{attrs:{"id":"input-group-3","label":"Tipo de Proceso:","label-for":"input-3"}},[_c('b-form-select',{attrs:{"id":"input-1","value":_vm.form.process_type,"options":_vm.process_types,"value-field":"id","required":""},on:{"input":_vm.updateProcessType}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }